import { Link, usePage } from '@inertiajs/react';

import lawLyticsLogo from '@/images/lawlytics-logo.svg';
import lawLyticsLogoWhite from '@/images/lawlytics-logo-white.png';
import { cmsDashboardPath } from '@/lib/routes';
import { cn } from '@/lib/utils';
import type { SharedData } from '@/types/shared';

export type LawLyticsLogoVariant = 'default' | 'white';

type LawLyticsLogoProps = {
  variant?: LawLyticsLogoVariant;
  imgClassName?: string;
  className?: string;
};

export default function LawLyticsLogo({
  variant = 'default',
  imgClassName,
  className,
}: LawLyticsLogoProps) {
  const { currentUser } = usePage<SharedData>().props;
  const src = variant === 'white' ? lawLyticsLogoWhite : lawLyticsLogo;
  const image = (
    <img src={src} alt="LawLytics" className={cn('h-6 w-auto', imgClassName)} draggable={false} />
  );

  if (currentUser) {
    return (
      <Link href={cmsDashboardPath()} className={className}>
        {image}
      </Link>
    );
  }

  return (
    <a href="https://lawlytics.com" rel="noopener" className={className}>
      {image}
    </a>
  );
}
